import { useSelector } from "react-redux"
import { NavLink } from "react-router-dom"

export const SideBar = (props) => {
    const userType = useSelector(state => state.user.empType)
    const empId = useSelector(state => state.user.empId)
    if (userType == 101) {
        return (
            <div className="main-menu menu-fixed menu-light menu-accordion menu-shadow h-auto" data-scroll-to-active="true">
                <div className="shadow-bottom"></div>
                <div className="main-menu-content">
                    <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
                        <li className="nav-item text-center">
                            <NavLink to={"/"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                <i className="fas fa-home"></i>
                            </NavLink>
                        </li>
                        <li className="nav-item text-center">
                            <NavLink to={"/ideas"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                <i className="fas fa-lightbulb"></i>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to={"/jury-list"} className="d-flex text-center">
                                <i className="fas fa-crown"></i>
                            </NavLink>
                        </li>
                        {/* <li className="nav-item"><a className="d-flex text-center" href="admin-idea-categories.html"><i className="fas fa-tag"></i></a>
                                </li> */}
                        {/* <li className="nav-item"><a className="d-flex text-center" href="admin-departments.html"><i className="fas fa-building"></i></a>
                                </li> */}
                        {/* <li className="nav-item"><a className="d-flex text-center" href="admin-area-of-implementation.html"><i className="fas fa-share-alt"></i></a>
                        </li> */}
                        <li className="nav-item">
                            <NavLink to={"/users"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                <i className="fas fa-users"></i>
                            </NavLink>
                        </li>
                        {/* <li className="nav-item"><a className="d-flex text-center" href="admin-reports.html"><i className="fas fa-chart-pie"></i></a>
                        </li> */}

                    </ul>
                </div>
            </div>
        )
    } else if (userType == 152 || userType == 171) {
        return (
            <div className="main-menu menu-fixed menu-light menu-accordion menu-shadow h-auto" data-scroll-to-active="true">
                <div className="shadow-bottom"></div>
                <div className="main-menu-content">
                    <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
                        <li className="nav-item text-center">
                            <NavLink to={"/"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                <i className="fas fa-home"></i>
                            </NavLink>
                        </li>
                        <li className="nav-item text-center">
                            <NavLink to={"/ideas"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                <i className="fas fa-lightbulb"></i>
                            </NavLink>
                        </li>
                        <li className="nav-item text-center">
                            <NavLink to={"/jury-details"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"} >
                                <i className="fas fa-crown"></i>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
    else {

        return (
            <>
                <div className="main-menu menu-fixed menu-light menu-accordion menu-shadow h-auto" data-scroll-to-active="true">
                    <div className="shadow-bottom"></div>
                    <div className="main-menu-content">
                        <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
                            <li className="nav-item text-center">
                                <NavLink to={"/"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                    <i className="fas fa-home"></i>
                                </NavLink>
                            </li>
                            <li className="nav-item text-center">
                                <NavLink to={"/my-idea"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                    <i className="fas fa-lightbulb"></i>
                                </NavLink>
                            </li>
                            <li className="nav-item text-center">
                                <NavLink to={"/leader-board"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"}>
                                    <i className="fas fa-chart-line"></i>
                                </NavLink>
                            </li>
                            <li className="nav-item text-center">
                                <NavLink to={"/jury-details"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"} >
                                    <i className="fas fa-crown"></i>
                                </NavLink>
                            </li>
                            
                            {
                                (empId == "amit.ray" || empId == "aamir.ali" || empId == "deepak.s" || empId =="christina.john") && <li className="nav-item text-center">
                                <NavLink to={"/leader-boardstats"} className={({ isActive }) => (isActive ? "active" : "") + " d-flex text-center"} >
                                    <i className="fas fa-chart-area"></i>
                                </NavLink>
                            </li>
                            }
                        </ul>
                    </div>
                </div>
            </>
        )
    }
}